var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1325_1745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.64 8.38996C5.64 8.38996 5.61 8.33996 5.47 8.34996C5.16 8.36996 4.67 8.40996 4.67 8.40996C3.11 8.50996 1.83 10.4 1.55 12.89C1.53 13.12 1.5 14.04 1.5 14.2C1.6 17.08 3.03 19.37 4.79 19.37C4.79 19.37 5.1 19.35 5.52 19.33C5.66 19.33 5.82 19.31 5.97 19.31C6.01 19.31 6.06 19.26 6.02 19.19C5.94 19.06 5.86 18.92 5.78 18.77C5.04 17.4 4.45 15.48 4.56 12.86C4.62 11.34 5 9.82996 5.62 8.51996C5.65 8.45996 5.66 8.41996 5.64 8.38996Z",
    fill: "#090B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4101 11.98C21.4101 10.8 20.2301 10.53 20.2301 10.53C20.2301 10.53 21.8401 9.86999 21.1901 8.07999C20.8401 7.13999 19.7301 6.83999 18.8101 6.91999L14.3901 7.13999C14.3901 7.13999 15.7801 6.14999 16.2901 4.42999C16.7301 2.93999 16.3901 1.65999 15.8001 1.04999C14.9401 0.159989 13.8801 0.439989 13.4501 1.24999C12.9901 2.11999 12.8901 3.25999 11.5201 4.68999C10.8101 5.42999 8.34009 7.31999 8.34009 7.31999C8.34009 7.31999 8.08009 7.47999 7.78009 7.81999C7.13009 8.55999 6.16009 10.32 6.06009 12.91C5.95009 15.72 6.72009 17.58 7.52009 18.74C7.72009 19.03 8.02009 19.24 8.37009 19.31C8.83009 19.41 9.55009 19.56 10.2401 19.68C12.4101 20.06 14.1501 20.16 16.0901 19.87C17.0801 19.72 18.7101 19.42 19.1201 18.27C19.4301 17.37 19.1201 16.99 19.1201 16.99C19.1201 16.99 20.2301 16.88 20.6401 15.61C21.0101 14.46 20.2401 13.85 20.2401 13.85C20.2401 13.85 21.4101 13.59 21.4101 11.98Z",
    fill: "#090B0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1325_1745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.91,
    height: 19.55,
    fill: "white",
    transform: "translate(1.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.1c128ca1ea117d1cf87cb04879a0edf3.svg";
export { ForwardRef as ReactComponent };